import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ApolloCache, useApolloClient } from '@apollo/client';

import { masterUrl } from '@notino/shared/client-utils';
import { PathTemplate } from '@notino/shared/definitions/types';

import UpdateResolveUrlQuery from '@components/ClientRedirect/queries/updateResolveUrl.graphql';

const writeWishlistResolveUrl = (
  cache: ApolloCache<object>,
  targetPath: string
) => {
  const url = masterUrl(targetPath);
  cache.writeQuery({
    query: UpdateResolveUrlQuery,
    data: {
      resolveUrl: {
        __typename: 'PathView',
        id: btoa(url),
        path: url,
        productId: null,
        catalogId: null,
        type: PathTemplate.Wishlist,
      },
    },
    variables: {
      url,
    },
  });
};

type WishlistSpaNavigate = (
  targetPath: string,
  event?: React.MouseEvent
) => void;

export const useWishlistSpaNavigate = (): WishlistSpaNavigate => {
  const { cache } = useApolloClient();
  const navigate = useNavigate();

  return useCallback(
    (targetPath: string, event?: React.MouseEvent) => {
      window.scrollTo({
        top: 0,
        left: 0,
        // @ts-ignore
        behavior: 'instant', // typescript doesn't recognize instant, but it's described in docs - https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollTo
      });
      if (event) {
        event.preventDefault();
      }
      writeWishlistResolveUrl(cache, targetPath);
      navigate(targetPath);
    },
    [cache, navigate]
  );
};
